<template>
    <div id="app">
        <m-header :params="pageParams"></m-header>
        <section class="block-wrap content-wrap">
            <!--教育服务-->
            <div class="panel-wrap">
                <m-breadcrumb :link-list="linkList"></m-breadcrumb>

                <div class="block-content">
                    <div class="panel-menu">
                        <div class="panel-menu-item" v-for="(item, i) in pageData.panelMenuList" :key="item.key"
                            :class="{ 'active': i === pageState.panelMenuIndex }" @click="changeMenuItem(i)">
                            {{ item.title }}
                            <span v-if="i === pageState.panelMenuIndex">
                                <i class="el-icon-caret-right active-icon"></i>
                            </span>
                        </div>
                    </div>
                    <div class="panel-body" v-loading="loading">
                        <div class="search-wrap">
                            <el-select class="search-item" filterable v-model="searchParams.schoolId" placeholder="举办学校" clearable>
                                <el-option v-for="item in pageData.searchData.schoolList" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>

                            <!-- <el-select class="search-item" v-model="searchParams.user" placeholder="主办方">
                                <el-option
                                        v-for="item in pageData.searchData.placeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select> -->

                            <el-date-picker class="search-item" type="date" value-format="yyyy-MM-dd"
                                v-model="searchParams.beginTime" placeholder="举办时间" clearable>
                            </el-date-picker>

                            <el-input class="search-item" style="width: 260px" v-model="searchParams.keyword"
                                placeholder="请输入搜索关键字" clearable></el-input>

                            <el-button type="primary" class="search-btn" @click="search">搜 索</el-button>
                        </div>

                        <div class="panel-content" :class="{ 'career-content-block': currMenu.type === 'career' }">
                            <template v-for="item in pageData.panelBodyList[currMenu.key]">
                                <block-job-fair v-if="currMenu.type === 'jobfair'" class="panel-body-item" :item="item"
                                    :key="item.id" @click="goDetail(item.id)"></block-job-fair>

                                <div v-else class="panel-body-item career-item" :key="item.id" @click="goDetail(item.id)">
                                    <div class="career-date-wrap">
                                        <p class="day">{{ dateFormat(item.meetDate, "DD") }}</p>
                                        <p class="year">{{ dateFormat(item.meetDate, "YYYY-MM") }}</p>
                                    </div>
                                    <div class="career-content">
                                        <div class="tag">宣</div>
                                        <div class="text-block">
                                            <p class="main-tit">{{ item.title }}</p>
                                            <p class="sub-tit">{{ item.place }}</p>
                                            <p class="sub-tit">举办时间：{{ dateFormat(item.meetDate, "YYYY-MM-DD") }}</p>
                                            <p class="sub-tit">主办方：{{ item.schoolName }}</p>
                                        </div>
                                    </div>
                                </div>

                            </template>
                        </div>

                        <div class="pager-wrap" v-if="pageParams.pageInfo.totalCount > pageParams.pageInfo.pageSize">
                            <m-pager :total-count="pageParams.pageInfo.totalCount" :page-number="pageParams.pageInfo.page"
                                :page-size="pageParams.pageInfo.pageSize" @changePage="changePage"></m-pager>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <m-footer></m-footer>
    </div>
</template>
<script>
import mFooter from "@/components/mFooter";
import mHeader from "@/components/mHeader";
import mPager from "@/components/mPager";
import mBreadcrumb from "@/components/mBreadcrumb";
import blockJobFair from "@/components/blockJobFair";
import moment from 'moment'

export default {
    name: 'jobFair',
    data() {
        return {
            loading: false,
            pageState: { panelMenuIndex: 0 },
            searchParams: { schoolId: '', beginTime: '', keyword: '' },
            pageParams: {
                menuIndex: '/jobfair.html',
                // swipeHeight: '500px',
                pageInfo: {
                    totalCount: 6,
                    page: 1,
                    pageSize: 6
                }
            },
            pageData: {
                panelMenuList: [
                    { title: '双选会', key: 'jobfair', type: 'jobfair' },
                    { title: '宣讲会', key: 'career', type: 'career' },
                ],
                panelBodyList: {
                    'jobfair': [],
                    'career': []
                },
                searchData: {
                    schoolList: [],
                    placeList: [{
                        value: '选项1',
                        label: '黄金糕'
                    }, {
                        value: '选项2',
                        label: '双皮奶'
                    }],
                }
            },
        }
    },
    computed: {
        //左侧菜单
        currMenu() {
            return this.pageData.panelMenuList[this.pageState.panelMenuIndex];
        },
        //面包屑链接
        linkList() {
            return [
                { "title": '招聘会', "link": 'jobfair.html' },
                { "title": this.currMenu.title, 'link': "/jobfair.html?key=" + this.currMenu.key }
            ]
        }
    },
    components: {
        mFooter, mHeader, mPager, mBreadcrumb, blockJobFair
    },
    watch: {
        // //搜索参数
        // searchParams: {
        //     handler() {
        //         this.loadMore(true);
        //     },
        //     deep: true
        // }
    },
    methods: {
        dateFormat(date, format) {
            return moment(date).format(format);
        },
        //切换类型
        changeMenuItem(i) {
            if (i !== this.pageState.panelMenuIndex) {
                this.pageState.panelMenuIndex = i;
                this.initSearch();
                this.loadMore(true);
            }
        },
        //加载数据
        loadMore(refresh = false) {
            this.initPageInfo(refresh);
            if (this.currMenu.key === 'jobfair') {
                this.ajaxGetJobFair()
            } else {
                this.ajaxGetCareerList();
            }
        },
        //接口获取双选会
        ajaxGetJobFair() {
            this.loading = true;
            //请求接口数据
            let params = {
                ...this.pageParams.pageInfo,
                ...this.searchParams
            }
            this.$api.getJobFairList(params).then(data => {
                this.loading = false;
                if (data.code !== -1) {
                    const { items, total } = data;
                    this.$set(this.pageData.panelBodyList, 'jobfair', items)
                    this.$set(this.pageParams.pageInfo, 'totalCount', total);
                }
            });
        },
        //接口获取宣讲会
        ajaxGetCareerList() {
            this.loading = true;
            //请求接口数据
            let params = {
                ...this.pageParams.pageInfo,
                ...this.searchParams
            }
            this.$api.getCareerList(params).then(data => {
                this.loading = false;
                if (data.code !== -1) {
                    const { items, total } = data;
                    this.$set(this.pageData.panelBodyList, 'career', items)
                    this.$set(this.pageParams.pageInfo, 'totalCount', total);
                }
            });
        },
        //翻页
        changePage({ currentPage }) {
            if (this.pageParams.pageInfo.page !== currentPage) {
                this.pageParams.pageInfo.page = currentPage;
                this.loadMore();
            }
        },
        //点击查看详情
        goDetail(id) {
            this.$util.gotoDetail(this.currMenu.type, id);
        },
        //初始化翻页
        initPageInfo(refresh) {
            if (refresh) {
                this.pageParams.pageInfo = {
                    totalCount: 1,
                    page: 1,
                    pageSize: 9,
                }
            }
        },
        //初始化搜索数据
        initSearch() {
            this.pageParams.searchParams = {
                place: '',
                user: '',
                timeList: '',
                keyword: ''
            };
        },
        //点击搜索
        search() {
            this.loadMore(true);
        },
        statusLabel(){
        }
    },
    created() {
        let key = this.$util.getQueryString("key");
        let index = this.pageData.panelMenuList.findIndex(item => {
            return item.key === key;
        });
        if (index >= 0) {
            this.changeMenuItem(index);
        }
        this.$api.getSchoolList().then(data => {
            this.pageData.searchData.schoolList = data;
        })
        this.loadMore(true);
    }
}
</script>
<style lang="scss" scoped>
@import "@/common/sass/common.scss";

.content-wrap {
    width: 1400px;
    margin: 0 auto;
    overflow: hidden;
}

.panel-wrap {
    margin-top: 30px;
    background-color: #ffffff;

    .block-content {
        display: flex;
        width: 100%;

        .panel-menu {
            width: 240px;
            height: 100%;
            background: #F4F7FC;
            min-height: 300px;

            .panel-menu-item {
                position: relative;
                width: 240px;
                height: 60px;
                line-height: 60px;
                font-size: 16px;
                color: #333333;
                text-align: center;
                border-bottom: 1px solid #ddd;
                cursor: pointer;

                &.active {
                    background: #ffffff;
                    // border-top: 2px solid $mainColor;

                    .active-icon {
                        position: absolute;
                        right: 30px;
                        top: 50%;
                        margin-top: -7px;
                        color: $mainColor;
                        font-size: 14px;
                    }
                }
            }
        }

        .panel-body {
            padding-left: 40px;
            box-sizing: border-box;

            .panel-content {
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                margin-top: 42px;

                &.career-content-block {
                    margin-top: 22px;
                }

                .panel-body-item {
                    width: 350px;
                    margin: 0px 35px 30px 0;
                    cursor: pointer;

                    &:nth-of-type(3),
                    &:nth-of-type(6),
                    &:nth-of-type(9),
                    &:nth-of-type(12),
                    &:nth-of-type(15) {
                        margin-right: 0;
                    }

                    .block-img {
                        width: 100%;
                        height: 170px;
                    }
                }

                .career-item {
                    display: flex;
                    width: 100%;
                    border-bottom: 1px solid #F4F7FC;
                    padding: 25px 10px;
                    margin: 0;
                    box-sizing: border-box;

                    &:hover {
                        .career-content .text-block .main-tit {
                            color: $mainColor;
                        }
                    }

                    .career-date-wrap {
                        width: 85px;
                        position: relative;

                        .day {
                            font-size: 30px;
                            color: #1963D0;
                            line-height: 40px;
                        }

                        .year {
                            font-size: 14px;
                            color: #999999;
                            line-height: 20px;
                        }

                        &:after {
                            position: absolute;
                            content: '';
                            width: 2px;
                            height: 40px;
                            background: #F3F3F3;
                            right: 0;
                            top: 0;
                        }
                    }

                    .career-content {
                        width: calc(100% - 106px);
                        padding: 0 25px;
                        overflow: hidden;
                        display: flex;

                        .tag {
                            font-size: 14px;
                            font-weight: bold;
                            color: #FFFFFF;
                            width: 24px;
                            height: 24px;
                            background: #3889FF;
                            border-radius: 50%;
                            line-height: 24px;
                            text-align: center;
                        }

                        .text-block {
                            padding: 0 10px;

                            .main-tit {
                                font-size: 16px;
                                font-weight: bold;
                                color: #333333;
                                line-height: 30px;
                            }

                            .sub-tit {
                                font-size: 14px;
                                color: #888888;
                            }
                        }
                    }
                }
            }
        }
    }

    .search-wrap {
        width: 100%;
        height: 100px;
        background: #F4F7FC;
        padding: 30px 25px;
        box-sizing: border-box;

        .search-item {
            margin-right: 10px;
        }

        .search-btn {
            background-color: $mainColor;
            border-color: $mainColor;
        }
    }

    .pager-wrap {
        height: 100px;
        padding-top: 50px;
        box-sizing: border-box;
    }
}
</style>